module.exports = __webpack_public_path__ + "static/media/Druid_Feral_Tank.51b63e98.png";